import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {OFFER_CATEGORIES} from '@chekin/core';
import {RailSection} from '@chekinapp/ui';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {POSTHOG_EVENTS, useAnalytics} from 'analytics';
import {useHomeData} from '../useHomeData';
import {EsimStrip} from './EsimStrip';
import {TransferCard, ToursCard} from './ExtrasCards';
import {HostOffersList, HostOffersListSkeleton} from './HostOffersList';

export function HomeOffers() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {track} = useAnalytics();
  const {upsellItems, upsellLoading} = useHomeData();

  const hostOffers = upsellItems.filter(item => item.source === 'offer');
  const transfer = upsellItems.find(item => item.source === 'mozio');
  const tours = upsellItems.filter(item => item.source === 'guruwalk');
  const esim = upsellItems.find(item => item.source === 'esim');
  const hasExtras = Boolean(transfer) || tours.length > 0;

  const openAllOffers = () => {
    track(POSTHOG_EVENTS.RECOMMENDATIONS_CLICKED);
    navigate(getFullPath(PATHS.recommendations.main));
  };

  const openTours = () => {
    track(POSTHOG_EVENTS.RECOMMENDATIONS_CLICKED);
    navigate(
      getFullPath(
        `${PATHS.recommendations.main}?category=${OFFER_CATEGORIES.freeOffers}`,
      ),
    );
  };

  return (
    <>
      {(upsellLoading || hostOffers.length > 0) && (
        <RailSection label={t('offered_by_your_host')}>
          {upsellLoading ? (
            <HostOffersListSkeleton />
          ) : (
            <HostOffersList items={hostOffers} onSeeAll={openAllOffers} />
          )}
        </RailSection>
      )}
      {hasExtras && (
        <RailSection label={t('extras_for_your_stay')}>
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-1">
            {transfer && (
              <TransferCard
                imageUrl={transfer.imageUrl}
                onClick={transfer.onSelect}
                className={tours.length === 0 ? 'col-span-2 lg:col-span-1' : undefined}
              />
            )}
            {tours.length > 0 && (
              <ToursCard
                imageUrl={tours.find(tour => tour.imageUrl)?.imageUrl}
                onClick={openTours}
                className={!transfer ? 'col-span-2 lg:col-span-1' : undefined}
              />
            )}
          </div>
        </RailSection>
      )}
      {esim && <EsimStrip item={esim} className="lg:mt-auto" />}
    </>
  );
}
